import { render, staticRenderFns } from "./SearchManagerV2.vue?vue&type=template&id=39bf0658"
import script from "./SearchManagerV2.vue?vue&type=script&lang=js"
export * from "./SearchManagerV2.vue?vue&type=script&lang=js"
import style0 from "./SearchManagerV2.vue?vue&type=style&index=0&id=39bf0658&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports